<template>
<v-data-table
  :rows-per-page-items="rowsPerPageItems"
  :headers="headers"
  :items="reports"
  :loading="loading"
  hide-actions>
  <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
  <template v-slot:items="props">
    <!--<tr @click="props.expanded = !props.expanded" style="cursor:pointer">-->
    <tr>
      <td>{{ props.item.charger ? props.item.charger.managementNumber : '' }}</td>
      <td>{{ $_getReportDate(props.item) }}</td>
      <td>{{ props.item.checker ? props.item.checker.name : '' }}</td>
      <td>
        <!--<v-icon v-if="props.item.pictureUrls && props.item.pictureUrls.length > 0">photo</v-icon>-->
        <template v-if="props.item.pictureUrls">
          <v-icon v-for="url in props.item.pictureUrls" :key="url" @click="$_windowOpen(url)">photo</v-icon>
        </template>
      </td>

      <!--
      <template v-for="(checkItemKey, checkItemIndex) in checkItems">
      <td :class="$_isOkCheckItem(checkItemKey, props.item.checkItems[checkItemKey]) ? 'report_ok' : 'report_error'"
          :key="checkItemIndex">
          {{ props.item.checkItems[checkItemKey] }}
      </td>
      </template>
      -->

      <td>
        <template v-for="(checkItem, index) in checkItems.left">
          <v-chip v-if="props.item.checkItems['충전기(좌)'][checkItem] === '고장'" small color="warning" dark :key="index">
            <v-avatar>
              <v-icon>error</v-icon>
            </v-avatar>
            {{checkItem}}
          </v-chip>
          <v-chip v-else small :key="index">
            <v-avatar>
              <v-icon>done</v-icon>
            </v-avatar>
            {{checkItem}}
          </v-chip>
          <br v-if="index === 2" :key="index + '_br'"/>
        </template>
      </td>
      <td style="padding: 10px">
        <template v-for="(checkItem, index) in checkItems.right">
          <v-chip v-if="props.item.checkItems['충전기(우)'][checkItem] === '고장'" small color="warning" dark :key="index">
            <v-avatar>
              <v-icon>error</v-icon>
            </v-avatar>
            {{checkItem}}
          </v-chip>
          <v-chip v-else small :key="index">
            <v-avatar>
              <v-icon>done</v-icon>
            </v-avatar>
            {{checkItem}}
          </v-chip>
          <br v-if="index === 2" :key="index + '_br'"/>
        </template>
      </td>
    </tr>
  </template>
  <!--
  <template v-slot:expand="props">
    <v-card flat>
      <v-card-text>
        <v-alert v-if="props.item.momo != ''" :value="props.item.memo" type="warning">
          {{props.item.memo}}
        </v-alert>
        <br>

        <v-carousel v-if="props.item.pictureUrls.length > 0">
          <v-carousel-item v-for="(value, key) in props.item.pictureUrls"
          :src="value" :lazy-src="value" :key="key">
            <template v-slot:placeholder>
              <v-layout
                  fill-height
                  align-center
                  justify-center
                  ma-0>
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-layout>
            </template>
          </v-carousel-item>
        </v-carousel>

        <br>{{props.item.address ? props.item.address : props.item.location}}
      </v-card-text>
    </v-card>
  </template>
  -->
</v-data-table>
</template>

<script>
// import firebase from 'firebase'
import moment from 'moment'

export default {
  name: 'ReportMonthlyDataTable',
  props: {
    reports: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      loading: false,
      rowsPerPageItems: [10, 20, 30, 40],
      checkItems: {left: ['주전원', '타이머', '충전케이블', '하단스위치', '공기주입기', '기타'],
        right: ['주전원', '타이머', '충전케이블', '핸드폰충전', '청소에어', '기타']}
    }
  },
  computed: {
    /*
    checkItems () {
      const checkItemSet = new Set()

      this.reports.forEach(report => {
        for (var key in report.checkItems) {
          checkItemSet.add(key)
        }
      })

      return Array.from(checkItemSet).sort()
    },
    */
    headers () {
      const headers = [{text: '충전기', values: 'charger', sortable: false, width: '10%', align: 'center'},
        {text: '점검일', values: 'date', sortable: false, width: '15%', align: 'center'},
        {text: '점검자', values: 'checker', sortable: false, width: '10%', align: 'center'},
        {text: '첨부사진', values: 'pic', sortable: false, width: '5%', align: 'center'},
        {text: '충전기(좌)', values: 'portLeft', sortable: false, width: '30%', align: 'center'},
        {text: '충전기(우)', values: 'portRight', sortable: false, width: '30%', align: 'center'}]

      /*
      // TODO 기본 config 의 체크 항목 가지고 올 것
      // eslint-disable-next-line
      checkItemsFor:
      for (var i = 0; i < this.checkItems.length; i++) {
        // console.log(this.checkItems[i].text)

        for (var j = 0; j < headers.length; j++) {
          if (headers[j].text === this.checkItems[i]) {
            // eslint-disable-next-line
            continue checkItemsFor
          }
        }

        headers.push({text: this.checkItems[i], values: this.checkItems[i] + '_' + i, sortable: false, width: '10%'})
      }
      */
      return headers
    }
  },
  methods: {
    /*
    $_isOkCheckItem (key, value) {
      if (value === '정상' || (key === '장애물' && value === '없음')) {
        return true
      }

      return false
    },
    $_getCheckItems () {
      const checkItemSet = new Set()

      this.reports.forEach(report => {
        for (var key in report.checkItems) {
          checkItemSet.add(key)
        }
      })

      return Array.from(checkItemSet).sort()
    },
    */
    $_getCheckResultHtml (checkItem, key) {
      return `<v-chip small color="warning" dark>
          <v-avatar>
            <v-icon>error</v-icon>
          </v-avatar>
          메인스위치
        </v-chip>`

      /*
      return key +
          ' : <span style="color:' + (checkItem[key] === '고장' ? 'red' : '') + '">' +
          checkItem[key] + '</span>'
          */
    },
    $_getReportDate (report) {
      return moment(report.created.toDate()).format('YYYY-MM-DD HH:mm')
    },
    $_windowOpen (url) {
      window.open(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .report_ok {
    color:rgba(0,0,0,.87)
  }

  .report_error {
    color:red
  }

  td {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportMonthlyDataTable.vue